export { uiTranslations, getT, formatT } from './uiTranslations';
export { positionLabels, positionDescriptionsI18n, getPositionLabel, getPositionDescription } from './categoryTranslations';

export const LANG_STORAGE_KEY = 'helport_lang';
export const LANG_USER_SET_KEY = 'helport_lang_user_set';

export const getStoredLang = () => {
  try {
    const userSet = localStorage.getItem(LANG_USER_SET_KEY);
    const stored = localStorage.getItem(LANG_STORAGE_KEY);
    if (userSet === '1' && (stored === 'en' || stored === 'zh')) return stored;
  } catch {
    // ignore
  }
  return 'en';
};

export const storeLang = (lang) => {
  try {
    localStorage.setItem(LANG_STORAGE_KEY, lang);
    localStorage.setItem(LANG_USER_SET_KEY, '1');
  } catch {
    // ignore
  }
};
